import React from "react";
import Homepage from "./Homepage";
import "./styles/homepage.css";

function App1() {
  return (<Homepage />);
};

export default App1;
